module.exports = __webpack_public_path__ + "img/img_brand_hover_2.a84dd37c.svg";